import styled from "@emotion/styled";

const CheckboxWrapper = styled.div<{ white?: boolean; active?: boolean }>`
  width: 18px;
  height: 18px;
  cursor: pointer;
  margin-right: 10px;
  border-radius: 3px;
  border: 2px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${props => (props.white ? "white" : "black")};
  background-color: ${props =>
    props.active ? (props.white ? "white" : "black") : "transparent"};
`;
CheckboxWrapper.defaultProps = { active: false };

const styles = { CheckboxWrapper };

export default styles;
